module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"PageTextPage":{"breadcrumbs":{"base":"Vše o nákupu"},"verticalMenuLinks":{"ariaLabel":"Menu o nákupu","heading":"O nákupu"}}},"en":{"PageTextPage":{"breadcrumbs":{"base":"All about shopping"},"verticalMenuLinks":{"ariaLabel":"Purchase menu","heading":"About the purchase"}}}}')
  delete Component.options._Ctor
}
